import React from 'react';
import { DownloadAppSectionView } from './DownloadAppSectionView';

export default function DownloadAppSection() {
  return (
    <DownloadAppSectionView />
  );
}

